import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vClickOutside from 'v-click-outside'

require('./assets/util/analytics/mixpanel')

var numeral = require('numeral')

Vue.config.productionTip = false

Vue.filter('formatNumber', function(value) {
  return numeral(value).format('0,0') // displaying other groupings/separators is possible, look at the docs
})

Vue.filter('formatNumber', function(value) {
  return numeral(value).format('0,0') // singular and pularls filter
})

Vue.filter('singularPlural', function(value, input) {
  if (value > 1) return input + 's'
  return input // single and pularls filter
})

Vue.filter('ellipsisText', function(name, number) {
  if (name.length > number) return name.substring(0, number - 1) + '...'
  return name // Ellipsis text
})

Vue.use(vClickOutside)

window.prospector = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
